var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 116,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e7ebee",
    d: "M71.3 101.6c28 0 50.7-22.7 50.7-50.8S99.3 0 71.3 0 20.6 22.7 20.6 50.8s22.7 50.8 50.7 50.8m56.5-71.7a4.1 4.1 0 1 0 0-8.201 4.1 4.1 0 0 0 0 8.2zm6-16.1a2.8 2.8 0 1 0 0-5.601 2.8 2.8 0 0 0 0 5.6zm-116.6 19a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6m5.2 60.9a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M111.616 82.87H31.184a8.73 8.73 0 0 1-8.784-8.784V27.784A8.73 8.73 0 0 1 31.184 19h80.432a8.73 8.73 0 0 1 8.784 8.784v46.302a8.73 8.73 0 0 1-8.784 8.783z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6d0d7",
    d: "M47.245 68.44H34.446a1.98 1.98 0 0 1-2.008-2.008c0-1.13.879-2.008 2.008-2.008h12.8c1.128 0 2.007.878 2.007 2.007s-.879 2.008-2.008 2.008zm20.705 0h-12.8a1.98 1.98 0 0 1-2.007-2.008c0-1.13.878-2.008 2.007-2.008h12.8c1.129 0 2.007.878 2.007 2.007s-.878 2.008-2.008 2.008zm20.703 0H75.855a1.98 1.98 0 0 1-2.007-2.008c0-1.13.878-2.008 2.008-2.008h12.798c1.13 0 2.008.878 2.008 2.007s-.878 2.008-2.008 2.008zm20.705 0h-12.8a1.98 1.98 0 0 1-2.007-2.008c0-1.13.879-2.008 2.008-2.008h12.799c1.129 0 2.007.878 2.007 2.007s-.878 2.008-2.007 2.008z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#869aa9",
    d: "M104.715 44.347a7.529 7.529 0 1 0 0-15.058 7.529 7.529 0 0 0 0 15.058"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6d0d7",
    d: "M94.802 44.347a7.529 7.529 0 1 0 0-15.058 7.529 7.529 0 0 0 0 15.058M48.374 46.73H34.321c-1.004 0-1.883-.878-1.883-1.882v-9.034c0-1.004.879-1.882 1.883-1.882h13.928c1.004 0 1.882.878 1.882 1.882v9.034c.126 1.004-.753 1.883-1.757 1.883z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M128.113 83.643c-.4 1.7-1 3.5-1.7 5-1.9 3.7-4.9 6.6-8.6 8.5-3.8 1.9-8.3 2.7-12.8 1.7-10.6-2.2-17.4-12.6-15.2-23.2s12.5-17.5 23.1-15.2c3.8.8 7.1 2.7 9.9 5.3 4.7 4.7 6.7 11.5 5.3 17.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.213 77.942h-4.5v-4.5c0-.9-.7-1.7-1.7-1.7-.9 0-1.7.7-1.7 1.7v4.5h-4.5c-.9 0-1.7.7-1.7 1.7s.7 1.7 1.7 1.7h4.5v4.5c0 .9.7 1.7 1.7 1.7.9 0 1.7-.7 1.7-1.7v-4.5h4.5c.9 0 1.7-.7 1.7-1.7s-.8-1.7-1.7-1.7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 71.368,
    x2: 71.368,
    y1: 17.523,
    y2: 83.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ecf0f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 89.382,
    x2: 128.559,
    y1: 79.642,
    y2: 79.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 142,
    height: 107.869,
    x: 0.4,
    y: 8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6994_66425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6994_66425",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCard);
export default __webpack_public_path__ + "static/media/emptyCard.f27efea8cd9427e01dfa2117b0f4cb3c.svg";
export { ForwardRef as ReactComponent };